const MONTH_NAMES = [
  "jan", "fev", "mar", "abr", "mai", "jun",
  "jul", "ago", "set", "out", "nov", "dez",
];

export const fmtBRL = (v) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: 0,
  }).format(v || 0);

export const fmtBRLc = (v) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(v || 0);

export const fmtPct = (v) => `${(v ?? 0).toFixed(1)}%`;

export const fmtNum = (v) => new Intl.NumberFormat("pt-BR").format(v || 0);

export const fmtCompact = (v) =>
  new Intl.NumberFormat("pt-BR", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(v || 0);

export const fmtMonth = (ym) => {
  if (!ym) return "";
  const [y, m] = ym.split("-");
  return `${MONTH_NAMES[Number(m) - 1]}/${y.slice(2)}`;
};

export const PERIODS = [
  { value: "month", label: "Mês atual" },
  { value: "previous_month", label: "Mês anterior" },
  { value: "quarter", label: "Trimestre" },
  { value: "year", label: "Ano" },
];
